import React from 'react';
import { Dropdown, colors } from '@insurancemenu/imenu-components-lib';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { SubscribersSortBy, SubscribersSortOrder } from 'types/electionService';
import { ActiveSorting } from 'store/ui-stores/elections/employeeElectionsStore';
import { ActionButtonStyled } from '../styles';
import { ActiveSortingOptionIconStyled, DropdownOptionLabelStyled, OptionLabelStyled } from './styles';

export interface ElectionSortProps {
  activeSortValue: ActiveSorting;
  updateSortOrder: (sortOrderValue: SubscribersSortOrder) => void;
  updateSubscribersSortBy: (sortByValue: SubscribersSortBy) => void;
  updateActiveSortValue: (sortValue: ActiveSorting) => void;
}

const ElectionSort = ({
  activeSortValue,
  updateSortOrder,
  updateSubscribersSortBy,
  updateActiveSortValue,
}: ElectionSortProps): JSX.Element => {
  const renderDropdownOptionLabel = (currentSort: ActiveSorting, label: string): JSX.Element => {
    const isCurrentPropActive = activeSortValue === currentSort;
    return (
      <DropdownOptionLabelStyled>
        {isCurrentPropActive && <ActiveSortingOptionIconStyled width="2rem" height="2rem" color={colors.blue[600]} />}
        <OptionLabelStyled $isActive={isCurrentPropActive}>{label}</OptionLabelStyled>
      </DropdownOptionLabelStyled>
    );
  };

  const sortOptions: DropdownOptionType[] = [
    {
      value: 'a-z',
      label: renderDropdownOptionLabel(ActiveSorting.ASC, 'Alphabetically A - Z'),
      onOptionClick: (): void => {
        updateSortOrder(SubscribersSortOrder.ASC);
        updateSubscribersSortBy(SubscribersSortBy.NAME);
        updateActiveSortValue(ActiveSorting.ASC);
      },
    },
    {
      value: 'z-a',
      label: renderDropdownOptionLabel(ActiveSorting.DESC, 'Alphabetically Z - A'),
      onOptionClick: (): void => {
        updateSortOrder(SubscribersSortOrder.DESC);
        updateSubscribersSortBy(SubscribersSortBy.NAME);
        updateActiveSortValue(ActiveSorting.DESC);
      },
    },
    {
      value: 'elected-first',
      label: renderDropdownOptionLabel(ActiveSorting.ELECTED_FIRST, 'Elected first'),
      onOptionClick: (): void => {
        updateSubscribersSortBy(SubscribersSortBy.ELECTED);
        // sort in ASC order
        updateSortOrder(SubscribersSortOrder.DESC);
        updateActiveSortValue(ActiveSorting.ELECTED_FIRST);
      },
    },
    {
      value: 'elected-last',
      label: renderDropdownOptionLabel(ActiveSorting.ELECTED_LAST, 'Elected last'),
      onOptionClick: (): void => {
        updateSubscribersSortBy(SubscribersSortBy.ELECTED);
        // sort in DESC order
        updateSortOrder(SubscribersSortOrder.ASC);
        updateActiveSortValue(ActiveSorting.ELECTED_LAST);
      },
    },
  ];

  return (
    <Dropdown
      name="sort"
      options={sortOptions}
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_RIGHT}
      optionsWidth="20rem"
      closedElement={
        <ActionButtonStyled
          size="large"
          color="custom"
          customColor={colors.neutral.white}
          rightIconProp={<ChevronDown />}
          $isSelected={false}
        >
          Sort
        </ActionButtonStyled>
      }
      openedElement={
        <ActionButtonStyled
          size="large"
          color="custom"
          customColor={colors.neutral.white}
          rightIconProp={<ChevronUp />}
          $isSelected
        >
          Sort
        </ActionButtonStyled>
      }
    />
  );
};

export default ElectionSort;
